import React, { ReactElement } from 'react';
import ReactMarkdown from 'react-markdown';

interface Props {
  text: string;
  className?: string;
}

const Markdown = ({ text, className }: Props): ReactElement => (
  <ReactMarkdown className={className} escapeHtml={false} source={text} />
);

export default Markdown;
